<template>
  <v-card
    class="tile"
    outlined
  >
    <div class="tile-label">
      {{ label }}
    </div>
    <div class="tile-value">
      {{ value }}
    </div>
    <div class="tile-detail">
      {{ detail }}
    </div>
  </v-card>
</template>

<script>
/**
 * A number on a report dashboard, with its label and an optional detail line.
 */
export default {
  props: {
    detail: {
      default: '',
      type: String
    },
    label: {
      required: true,
      type: String
    },
    value: {
      required: true,
      type: String
    }
  }
};
</script>
